import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import s from './MoneyPromoButton.scss';
const MoneyPromoButton = ({ user, moneyPromo, relevantDeviation })=>{
    const { t } = useTranslation();
    let link = null;
    let ctaKey;
    if (moneyPromo === 'tier') {
        link = Url.userSubscriptionsPath({
            username: user.username
        });
        ctaKey = `submissionDetailsHeader.moneyPromo.var.tier.CTA`;
    } else {
        link = Url.userLink(user.username, USER_PROFILE_SECTION_PATHS.SHOP);
        ctaKey = `submissionDetailsHeader.moneyPromo.var.generic.CTA`;
    }
    return /*#__PURE__*/ React.createElement(BiLink, {
        className: s['root'],
        href: link,
        biData: relevantDeviation ? BiData({
            evid: 547,
            typeid: relevantDeviation.typeId,
            itemid: relevantDeviation.deviationId,
            referral_info: ReferralType.ART_STAGE_PROMOTION
        }) : undefined
    }, t(ctaKey));
};
MoneyPromoButton.displayName = 'MoneyPromoButton';
export default MoneyPromoButton;
